module.exports = __webpack_public_path__ + "img/felipe.abffeb5e.png";